import palette from './palette';

const mainColorsF = site => {
  switch (site) {
    case 'CMBR':
      return palette.blue.blueCmineira;

    case 'VAMX':
      return palette.lightBlue.base;

    case 'UBPE':
      return palette.green.darkPE;

    default:
      return palette.orange.base;
  }
};

export default mainColorsF;
